/*
 * @Author: your name
 * @Date: 2020-03-12 09:26:46
 * @LastEditTime: 2022-02-23 18:18:22
 * @LastEditors: zlh
 * @Description: In User Settings Edit
 * @FilePath: \gta_aitraining_vue\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createBlock from './modules/blocklyEditer/createBlock'
import blocklyHome from './modules/blocklyEditer/blocklyHome'
import menuListStore from './modules/menuList/menuList'
import gameEditor from './modules/gameEditor/gameEditor'
// import experianceHome from "./modules/experianceAI/experianceHome";
Vue.use(Vuex)
const service_data =
  process.env.NODE_ENV === 'production'
    ? window.gtaAiConfig.service_data
    : '/service_data'

/* eslint-disable */
let tag = process.env.VUE_APP_TAG
//全局函数
let smsUrl = getEnv(tag).smsUrl

export default new Vuex.Store({
  // 数据状态申明
  state: {
    appId: window.gtaAiConfig.appId,
    tenantId: sessionStorage.tenantId || '',
    teachingCourseId: window.gtaAiConfig.teachingCourseId,
    smsUrl: smsUrl, //教学中心对应的赛名师url；
    smsPath: window.gtaAiConfig.smsPath, //定位到赛名师的路径
    token: sessionStorage.token ? sessionStorage.token : '',
    userType: sessionStorage.accountInfo
      ? JSON.parse(sessionStorage.accountInfo).userType
      : '',
    accountInfo: sessionStorage.accountInfo
      ? JSON.parse(sessionStorage.accountInfo)
      : {},
    hasLogin: false,
    uploadUrl: null,
    currentUser: null,
    userRole: parseInt(sessionStorage.userRole) || null, // 老师1，学生2，校管理员3，超级管理员4
    //blockly的状态
    dragBlockStatu: false,
    markdownDoc: 'a', //markdown文本内容
    // 实训项目数据类型
    projectTypeArr: [
      {
        dictId: '1',
        dictTypeDesc: '算法编程应用',
      },
      {
        dictId: '2',
        dictTypeDesc: '智能硬件应用',
      },
      // {
      //   dictId: '3',
      //   dictTypeDesc: '数据标注应用',
      // },
      {
        dictId: '4',
        dictTypeDesc: '行业创研应用',
      },
    ],
    running: false,
  },
  getters: {
    appId: (state) => state.appId,
    tenantId: (state) => state.tenantId,
    teachingCourseId: (state) => state.teachingCourseId,
    smsUrl: (state) => state.smsUrl,
    smsPath: (state) => state.smsPath,
    uploadUrl: (state) => {
      const service_data = window.gtaAiConfig.service_data
      return service_data + '/api/upload/uploadMultipleFile'
    },
    accountInfo: (state) => state.accountInfo,
    token: (state) => state.token,
    hasLogin: (state) => state.hasLogin,
    userType: (state) => state.userType,
    userRole: (state) => state.userRole, // 老师1，学生2，校管理员3，超级管理员4
    projectTypeArr: (state) => state.projectTypeArr, // 实训项目数据类型
    dragBlockStatu: (state) => state.dragBlockStatu,
    markdownDoc: (state) => state.markdownDoc,
    running: (state) => state.running,
  },
  // 同步操作，并写入缓存
  mutations: {
    token: (state, val) => {
      state.token = val
    },
    setTenantId: (state, val) => {
      state.tenantId = val
    },
    userType: (state, val) => {
      state.userType = val
    },
    accountInfo: (state, val) => {
      state.accountInfo = val
    },
    userStatus(state, val) {
      state.hasLogin = val
    },
    uploadUrl(state, val) {
      const service_data = service_data
      state.uploadUrl = service_data
    },
    setUserRole(state, val) {
      state.userRole = val
    },
    projectTypeArr(state, val) {
      state.projectTypeArr = val
    },
    quitLogin(state) {
      state.token = ''
      state.accountInfo = {}
      state.userType = null
      state.userRole = null
    },
    setMarkdownDoc(state, val) {
      state.markdownDoc = '"' + val + '"'
    },
    setPythonRunning(state, val) {
      state.running = val
    },
  },
  actions: {
    //选课接口
    // async selectNewCourse({ commit, state }, CourseId) {
    //     let token = state.token,
    //         UserId = state.accountInfo.UserId,
    //         data = {
    //             CourseId,
    //             UserId
    //         };
    //     const res = await CourseSelect.selectNewCourse(data, token);
    //     return res;
    // },
    //取消选课接口
    // async cancelSelectCourse({ commit, state }, guid) {
    //     let token = state.token;
    //     if (!guid) return;
    //     let res = await CourseSelect.cancelSelectCourse(guid, token);
    //     return res;
    // }
  },
  modules: {
    CREATEBLOCK: createBlock,
    blocklyHome: blocklyHome,
    menuListStore: menuListStore,
    gameEditor: gameEditor,
    // experianceHome: experianceHome
  },
})
